export const COUNTRY_MAP = {
  EU: 'EU',
  US: 'US',
  AU: 'AU',
  CA: 'CA',
  AE: 'AE',
  BR: 'BR',
  IN: 'IN',
  MX: 'MX',
};

export const LOCALES_MAP = {
  FR_FR: 'fr-FR',
  EN_US: 'en-US',
  ES_ES: 'es-ES',
  IT_IT: 'it-IT',
};

export const INTERNAL_USER_IDENTIFIER = "@amazon.com";